import { render, staticRenderFns } from "./ManpowerSupport.vue?vue&type=template&id=b53ebf30&"
import script from "./ManpowerSupport.vue?vue&type=script&lang=js&"
export * from "./ManpowerSupport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports